import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import { RoutesObj } from "../../../../../routes";
import {
  EditIcon,
  SortIcon,
  StarFill,
  StarOutline,
  ViewEye,
  Delete,
} from "../../../LeftNav/SvgIcons";
import { contactsActions } from "../../../../../store/contacts/contactsActions";
import { toast } from "react-toastify";
import { LightenDarkenColor } from "lighten-darken-color";
import moment from "moment";
import CSVFile from "../../../../../components/common/ExportCSVFile/CSVFile";
import { Img } from "react-image";
import { noImage } from "../../../../../resources/images";
import { DeletePopup } from "../../../../../components/common";

const useStyles = makeStyles(theme => ({
  gridTopNav: {
    padding: "10px 0 10px 0",
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    alignItems: "center",
    // minHeight: "23px",
  },
  deleteItems: {
    display: "flex",
    alignItems: "center",
  },
  gridHeaderInner: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "12px",
    paddingBottom: "9px",
  },
  gridHeader: {
    background: "#E5F2FF",
    borderRadius: "6px",
  },
  gridHeaderRow: {
    borderRadius: "6px",
  },
  checkBoxFont: {
    fontSize: "22px",
  },
  gridBodyInner: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "4px",
    paddingBottom: "4px",
  },
}));

const AllCompaniesGrid = ({
  setLoading,
  listData,
  loadData,
  order,
  onOrderBy,
  onMarkFavouriteCompanies,
  isDeleted = false,
  isArchived = false,
  isBlocked = false,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isPermanentDelete, setIsPermanentDelete] = useState(false);
  const [csvData, setCsvData] = useState([]);

  const redirectUrl = (value, isView) => {
    history.push({
      pathname: RoutesObj.BusinessCustomer.path,
      companyId: value.companyId,
      search: `id=${value.companyId}${isView ? `&acitveTabId=${isView}` : ""}`,
      state: { scrollTo: ".businessContacts" },
    });
  };

  const onItemSelect = itemId => {
    const itemExists =
      selectedCompanies.length > 0 && selectedCompanies.find(c => c === itemId);
    if (itemExists) {
      setSelectedCompanies(selectedCompanies.filter(c => c !== itemId));
    } else {
      setSelectedCompanies([...selectedCompanies, itemId]);
    }
  };

  const deleteCompanies = (ids, type, isPermanent = false) => {
    setLoading(true);
    dispatch(contactsActions.onDeleteCompanies(ids, isPermanent)).then(res => {
      if (!res?.success) {
        toast.error(res.message);
        setLoading(false);
      } else {
        toast.success(`Company mark as ${type}`);
        loadData();
        setSelectedCompanies([]);
      }
    });
  };

  const changeCompaniesStatus = (ids, type) => {
    setLoading(true);
    dispatch(contactsActions.onChangeCompaniesStatus(ids)).then(res => {
      if (!res?.success) {
        toast.error(res.message);
        setLoading(false);
      } else {
        toast.success(ids.ids.length > 1 ? `Companies marked as ${type}` : `Company marked as ${type}`);
        loadData();
        setSelectedCompanies([]);
      }
    });
  };

  useEffect(() => {
    if (isAllSelected === true) {
      const allComapniesIds = listData.map(l => l.companyId);
      setSelectedCompanies(allComapniesIds);
    } else {
      setSelectedCompanies([]);
    }
  }, [isAllSelected, listData]);

  const headers = [
    { label: "Company Name", key: "CompanyName" },
    { label: "No. of Contacts", key: "TotalUsers" },
    { label: "Business Group", key: "BusinessGroup" },
    { label: "Last Login", key: "LastLogin" },
  ];

  // const dataForExport = listData.map(item => ({
  //   CompanyName: item.companyName || "-",
  //   TotalUsers: `${item.totalUsers} Contacts`,
  //   BusinessGroup: item.businessGroup || "-",
  //   LastLogin: item.lastLogin ? moment(item.lastLogin).format("MM/DD/YYYY") : "-",
  // }));

  const handleExport = () => {
    setLoading(true);
    dispatch(contactsActions.onGetAllContactsByType("BusinessCompany")).then(
      data => {
        if (data?.success && data?.data) {
          const dataForExport = data?.data?.map(item => ({
            CompanyName: item.companyName || "-",
            TotalUsers: `${item.totalUsers} Contacts`,
            BusinessGroup: item.businessGroup || "-",
            LastLogin: item.lastLogin
              ? moment(item.lastLogin).format("MM/DD/YYYY")
              : "-",
          }));
          setCsvData(dataForExport);
        } else {
          setCsvData([]);
        }
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Paper className={classes.gridTopNav} style={{ paddingTop: "10px" }}>
        {/* <CSVFile
          data={csvData}
          headers={headers}
          filename="campanies-data.csv"
          handleExport={handleExport}
        /> */}
        {selectedCompanies.length > 0 && (
          <Grid
            item
            md={9}
            className={(classes.deleteItems, "tableGridActions")}>
            {!isDeleted ? <Button
              onClick={() =>
                deleteCompanies(
                  {
                    ids: selectedCompanies,
                    status: -1,
                  },
                  "delete"
                )
              }>
              Delete
            </Button> : (
                <>
                  <Button
                    onClick={() => setIsPermanentDelete(true)}>
                    Delete
                  </Button>
                  <Button
                    onClick={() =>
                      changeCompaniesStatus(
                        {
                          ids: selectedCompanies,
                          status: 1,
                        },
                        "active"
                      )
                    }>
                    Restore
                  </Button>
                </>
            )}
            <Button
              onClick={() => {
                let status = 3;
                if (isArchived) {
                  status = 1;
                }
                changeCompaniesStatus(
                  {
                    ids: selectedCompanies,
                    status,
                  },
                  isArchived ? "unarchive" : "archive"
                )
              }}>
              {isArchived ? "Unarchive" : "Archive"}
            </Button>
            <Button
              onClick={() => {
                let status = 2;
                if (isBlocked) status = 1;
                changeCompaniesStatus(
                  {
                    ids: selectedCompanies,
                    status,
                  },
                  isBlocked ? "unblock" : "block"
                )
              }}>
              {isBlocked ? "UnBlock" : "Block"}
            </Button>
          </Grid>
        )}
      </Paper>
      <Table>
        <TableHead className={classes.gridHeader}>
          <TableRow className={classes.gridHeaderRow}>
            <TableCell className={classes.gridHeaderInner}>
              <Checkbox
                className={classes.checkBoxFont}
                checked={isAllSelected}
                onClick={() => setIsAllSelected(!isAllSelected)}
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Company Name
              <TableSortLabel
                active={order.orderByKey === "CompanyName"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "CompanyName",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              No. of Contacts
              <TableSortLabel
                active={order.orderByKey === "TotalUsers"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "TotalUsers",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              No. of Locations
              <TableSortLabel
                active={order.orderByKey === "TotalLocations"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "TotalLocations",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Business Group
              <TableSortLabel
                active={order.orderByKey === "BusinessGroup"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "BusinessGroup",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Contact Type
              <TableSortLabel
                active={order.orderByKey === "ContactTypeName"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "ContactTypeName",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Last Login
              <TableSortLabel
                active={order.orderByKey === "LastLogin"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "LastLogin",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell
              className={
                (classes.gridHeaderInner, "quickLinkWrapper quickLinkHeader")
              }>
              Quick Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listData?.map((item, index) => {
            return (
              <TableRow
                key={index}
                className={`gridBodyRow endUserRow ${
                  selectedCompanies.length > 0 &&
                  selectedCompanies?.includes(item.companyId)
                    ? "boxChecked"
                    : " "
                }`}>
                <TableCell className={(classes.gridHeaderInner, "gridRow")}>
                  <Checkbox
                    className={(classes.checkBoxFont, "enduserCheckbox")}
                    onClick={() => onItemSelect(item.companyId)}
                    checked={
                      selectedCompanies.length > 0 &&
                      selectedCompanies?.includes(item.companyId)
                    }
                  />
                  <span className='endUserPic'>
                    {item.image ? (
                      <Img src={[item.image, noImage]} />
                    ) : (
                      <i className='userInitials'>{`${
                        item?.companyName?.charAt(0)?.toUpperCase() ?? ""
                      }`}</i>
                    )}
                  </span>
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "capitalize-first")}>
                  {item.companyName}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "tableItemHighlight")}>
                  {`${item.totalUsers} Contact${
                    item.totalUsers > 1 ? "s" : ""
                  }`}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "tableItemHighlight")}>
                  {`${item.totalLocations} Location${
                    item.totalLocations > 1 ? "s" : ""
                  }`}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "tableItemHighlight")}>
                  {item?.businessGroup || "-"}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "tableItemHighlight")}>
                  {item?.contactTypeName || "-"}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "lastLoginWrapper")}>
                  {item.lastLogin
                    ? moment(item.lastLogin).format("MM/DD/YYYY")
                    : "-"}
                </TableCell>
                <TableCell
                  className={(classes.gridBodyInner, "quickLinkWrapper")}>
                  <div className='gridActions'>
                    <span
                      onClick={() => {
                        onMarkFavouriteCompanies({
                          selectedCustomers: {
                            companyId: item.companyId,
                            isFavourite: !item?.isFavourite,
                          },
                        });
                      }}>
                      {item?.isFavourite ? <StarFill /> : <StarOutline />}
                    </span>
                    <span onClick={() => redirectUrl(item)}>
                      <EditIcon />
                    </span>
                    <span onClick={() => redirectUrl(item, "1")}>
                      <ViewEye />
                    </span>
                    <span
                      onClick={() => {
                        if (isDeleted) {
                          setSelectedCompanies([item?.id]);
                          setIsPermanentDelete(true);
                        } else {
                          deleteCompanies(
                            {
                              ids: [item?.id],
                              status: -1,
                            },
                            "delete"
                          )
                        }
                      }}>
                      <Delete />
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
          {listData.length <= 0 && (
            <TableRow key='0' className='gridBodyRow'>
              <TableCell
                colSpan='6'
                className={classes.gridBodyInner}
                style={{ textAlign: "center" }}>
                <span className='emptyGridText'>
                  Uh Oh! You haven’t created any company.
                </span>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {isPermanentDelete && (
        <DeletePopup
          maxwidth='1099px'
          isvisible={isPermanentDelete}
          oncloseaction={() => setIsPermanentDelete(false)}
          heading='Permanently Delete Company'
          deletemessage={`Are you sure you want to permanently delete Companies?`}
          subheading='Once a company is permanently deleted, you will no longer have access to their information.'
          cancelbtn={() => setIsPermanentDelete(false)}
          deletebtn={() => {
            deleteCompanies(
              {ids: selectedCompanies, status: -1},
              "delete",
              true,
            );
            setIsPermanentDelete(false);
          }}
        />
      )}
    </>
  );
};

export { AllCompaniesGrid };
